import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

const FooterTwo = () => {
    const { token } = useAuth()
    return (
        <footer className="footer py-80">
            <div className="container container-lg">
                <div className="footer-item-two-wrapper d-flex align-items-start flex-wrap">
                    <div className="footer-item max-w-275">
                        <div className="footer-item__logo">
                            <Link to="/">
                                {" "}
                                <img src="/assets/images/logo/logo-header2.png" alt="" />
                            </Link>
                        </div>
                        <p className="mb-24">
                            Fun Card has been offering savings coupons to customers for 18 years! If you have any questions please feel free to inquire directly.
                        </p>
                        <div className="flex-align gap-16 mb-16">
                            <span className="w-32 h-32 flex-center rounded-circle border border-gray-100 text-main-two-600 text-md flex-shrink-0">
                                <i className="ph-fill ph-phone-call" />
                            </span>
                            <span className="text-md text-gray-900">
                                +1 239 544 8005
                            </span>
                        </div>
                        <div className="flex-align gap-16 mb-16">
                            <span className="w-32 h-32 flex-center rounded-circle border border-gray-100 text-main-two-600 text-md flex-shrink-0">
                                <i className="ph-fill ph-envelope" />
                            </span>
                            <span className="text-md text-gray-900">
                                info@funcardmarketing.com
                            </span>
                        </div>
                        <div className="flex-align gap-16 mb-16">
                            <span className="w-32 h-32 flex-center rounded-circle border border-gray-100 text-main-two-600 text-md flex-shrink-0">
                                <i className="ph-fill ph-map-pin" />
                            </span>
                            <span className="text-md text-gray-900 ">
                                PO 272 Marco Island, Florida, 34146 USA
                            </span>
                        </div>
                    </div>
                    <div className="footer-item">
                        <h6 className="footer-item__title">My Account</h6>
                        <ul className="footer-menu">
                            <li className="mb-16">
                                <Link to={token ? "/user-dashboard" : "/account-login"} className="text-gray-600 hover-text-main-800">
                                    My Account
                                </Link>
                            </li>
                            <li className="mb-16">
                                <Link to={token ? "/user-dashboard" : "/account-login"} className="text-gray-600 hover-text-main-800">
                                    User Dashboard
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="footer-item">
                        <h6 className="footer-item__title">Information</h6>
                        <ul className="footer-menu">
                            <li className="mb-16">
                                <Link to="/become-seller" className="text-gray-600 hover-text-main-800">
                                    Become a Vendor
                                </Link>
                            </li>
                            <li className="mb-16">
                                <Link to="/tutorial" className="text-gray-600 hover-text-main-800">
                                    User Tutorial
                                </Link>
                            </li>
                            {/* <li className="mb-16">
                                <Link to="/privacy-policy" className="text-gray-600 hover-text-main-800">
                                    Privacy Policy
                                </Link>
                            </li> */}
                            <li className="mb-16">
                                <Link to="/blog" className="text-gray-600 hover-text-main-800">
                                    Blog
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="footer-item">
                        <h6 className="footer-item__title">Contact Us</h6>
                        <ul className="footer-menu">
                            <li className="mb-16">
                                <Link to="/contact" className="text-gray-600 hover-text-main-800">
                                    Contact Us
                                </Link>
                            </li>
                        </ul>
                    </div>
                    {/* <div className="footer-item">
                        <h6 className="">Shop on The Go</h6>
                        <p className="mb-16">Marketpro App is available. Get it now</p>
                        <div className="flex-align gap-8 my-32">
                            <Link to="/https://www.apple.com/store" className="">
                                <img src="/assets/images/thumbs/store-img1.png" alt="" />
                            </Link>
                            <Link to="/https://play.google.com/store/apps?hl=en" className="">
                                <img src="/assets/images/thumbs/store-img2.png" alt="" />
                            </Link>
                        </div>
                        <ul className="flex-align gap-16">
                            <li>
                                <Link
                                    to="/https://www.facebook.com"
                                    className="w-44 h-44 flex-center bg-main-two-600 text-white text-xl rounded-8 hover-bg-main-two-700 hover-text-white"
                                >
                                    <i className="ph-fill ph-facebook-logo" />
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/https://www.twitter.com"
                                    className="w-44 h-44 flex-center bg-main-two-600 text-white text-xl rounded-8 hover-bg-main-two-700 hover-text-white"
                                >
                                    <i className="ph-fill ph-twitter-logo" />
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/https://www.linkedin.com"
                                    className="w-44 h-44 flex-center bg-main-two-600 text-white text-xl rounded-8 hover-bg-main-two-700 hover-text-white"
                                >
                                    <i className="ph-fill ph-instagram-logo" />
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/https://www.pinterest.com"
                                    className="w-44 h-44 flex-center bg-main-two-600 text-white text-xl rounded-8 hover-bg-main-two-700 hover-text-white"
                                >
                                    <i className="ph-fill ph-linkedin-logo" />
                                </Link>
                            </li>
                        </ul>
                    </div> */}
                </div>
            </div>
        </footer>

    )
}

export default FooterTwo